/* eslint-disable */
import React, { useState, useEffect } from "react";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import JoditEditorField from "components/Common/JoditEditorField/JoditEditorField";
import { reactSelectStyle } from "Config/Config";
import { assetImages } from "constants";

import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import priorityOptions from "data/Prod/TaskPriority.json";
import DoctorDetailsCard from "../DoctorDetailsCard/DoctorDetailsCard";
import PatientDetailsCard from "../PatientDetailsCard/PatientDetailsCard";
import ClinicDetailsCard from "../ClinicDetailsCard/ClinicDetailsCard";
import NurseDetailsCard from "../NurseDetailsCard/NurseDetailsCard";

const SaveNursingPopup = ({
  afterActionClose = () => {},
  selectedNursingId = null,
  setSelectedNursingId = () => {},
  setShowAlert = () => {},
  setAlertMessage = () => {},
  setMessageType = () => {},
  patientObj = null,
  doctorObj = null,
  clinicObj = null,
}) => {
  const token = localStorage.getItem("token");

  const todayValue = new Date().toISOString().split("T")[0];

  // Form states
  const [title, setTitle] = useState("");
  const [scheduleFor, setScheduleFor] = useState(todayValue);
  const [priority, setPriority] = useState(null);
  const [doctor, setDoctor] = useState(null);
  const [patient, setPatient] = useState(null);
  const [clinic, setClinic] = useState(null);
  const [nurses, setNurses] = useState([]);
  const [details, setDetails] = useState("");
  const [instructions, setInstructions] = useState("");
  const [additionalInformation, setAdditionalNotes] = useState("");
  const [patientConsentRequired, setPatientConsentRequired] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  // Async load options for patient
  const loadPatientOptions = async (inputValue) => {
    try {
      const requestUrl =
        url.API_BASE_URL +
        url.API_GET_USER_LIST_BY_USER +
        `?token=${token}&userstringinput=${inputValue}&modulefrom=backend&filterroleslug=PATIENT`;

      const response = await getData(requestUrl);
      return response.data;
    } catch (error) {
      return [];
    }
  };

  // Async load options for doctor
  const loadDoctorOptions = async (inputValue) => {
    try {
      const requestUrl =
        url.API_BASE_URL +
        url.API_GET_USER_LIST_BY_USER +
        `?token=${token}&userstringinput=${inputValue}&modulefrom=backend&filterroleslug=DOCTOR`;

      const response = await getData(requestUrl);
      return response.data;
    } catch (error) {
      return [];
    }
  };

  // Async load options for nurses
  const loadNurseOptions = async (inputValue) => {
    try {
      const requestUrl =
        url.API_BASE_URL +
        url.API_GET_USER_LIST_BY_USER +
        `?token=${token}&userstringinput=${inputValue}&modulefrom=backend&filterroleslug=NURSE`;

      const response = await getData(requestUrl);

      return response.data;
    } catch (error) {
      return [];
    }
  };

  // Async load options for clinic
  const loadClinicOptions = async (inputValue) => {
    try {
      const requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_COMPANY_LIST +
        `?token=${token}&filtername=${inputValue}`;
      const response = await getData(requestUrl);
      return response.data;
    } catch (error) {
      return [];
    }
  };

  //reset all states
  const resetHandler = () => {
    setTitle("");
    setScheduleFor(todayValue);
    setPriority(null);
    setDoctor(doctorObj);
    setPatient(patientObj);
    setClinic(clinicObj);
    setDetails("");
    setInstructions("");
    setAdditionalNotes("");
    setPatientConsentRequired(false);
    setSelectedNursingId(null);
  };

  //get nursing details
  const getNursingDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_NURSING_DETAILS +
        `/${selectedNursingId}?token=${token}`;

      const response = await getData(requestUrl);

      console.log("nursing details response", response);

      if (response.status) {
        const data = response.data;

        setTitle(data.title);
        setScheduleFor(data.startdate);
        setPriority(
          priorityOptions.find((item) => item.value === data.priority)
        );
        setDoctor(data.doctorvalue);
        setPatient(data.patientvalue);
        setNurses(data.nursevalues);
        setClinic(data.clinicvalue);
        setDetails(data.description);
        setInstructions(data.medicalextension.nursinginstructions);
        setAdditionalNotes(data.medicalextension.additionalinformation);
        setPatientConsentRequired(data.medicalextension.ispatientconsent);
      }
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
      setShowAlert(true);
    }
  };

  //save nursing
  const saveNursingRecord = async () => {
    try {
      setIsSaving(true);
      const apiData = {
        title: title,
        startdate: scheduleFor,
        description: details,
        moderator: doctor ? doctor?.value : null,
        assigneduser: patient ? patient?.value : null,
        followers: nurses.map((item) => item.value),
        priority: priority ? priority.value : "",
        medicalextension: {
          clinicid: clinic ? clinic?.value : null,
          nursinginstructions: instructions,
          additionalinformation: additionalInformation,
          ispatientconsent: patientConsentRequired,
        },
      };

      console.log("apiData in save nursing", apiData);

      let requestUrl = url.API_BASE_URL;

      let response = {};

      if (selectedNursingId) {
        requestUrl +=
          url.API_UPDATE_NURSING + `/${selectedNursingId}?token=${token}`;
        response = await putData(requestUrl, apiData);
      } else {
        requestUrl += url.API_CREATE_NURSING + `?token=${token}`;
        response = await postData(requestUrl, apiData);
      }

      if (response.status) {
        setMessageType("success");
        setAlertMessage("Nursing task saved successfully");
        resetHandler();
        afterActionClose([response.data]);
        closeOffcanvas();
      }
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    } finally {
      setIsSaving(false);
      setShowAlert(true);
    }
  };

  const closeOffcanvas = () => {
    window.bootstrap.Offcanvas.getInstance(
      document.querySelector("#saveNursingOffCanvas")
    ).hide();
  };

  useEffect(() => {
    if (selectedNursingId) {
      getNursingDetails();
    }
  }, [selectedNursingId]);

  useEffect(() => {
    if (patientObj && !selectedNursingId) {
      setPatient(patientObj);
    }
  }, [patientObj, selectedNursingId]);

  useEffect(() => {
    if (doctorObj && !selectedNursingId) {
      setDoctor(doctorObj);
    }
  }, [doctorObj, selectedNursingId]);

  useEffect(() => {
    if (clinicObj && !selectedNursingId) {
      setClinic(clinicObj);
    }
  }, [clinicObj, selectedNursingId]);

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="saveNursingOffCanvas"
      aria-labelledby="saveNursingOffCanvas"
    >
      {/* Header */}
      <div className="offcanvas-header bg-primary text-white p-4 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              medical_services
            </span>
          </div>
          <div>
            <h3 className="offcanvas-title fw-bold text-white mb-0">
              {selectedNursingId ? "Edit Nursing Task" : "Add Nursing Task"}
            </h3>
            <p className="text-white fs-sm mb-0">
              {selectedNursingId
                ? "Update nursing task details"
                : "Create a new nursing task"}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-2 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>

      {/* Body */}
      <div className="offcanvas-body p-4">
        <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-light">
          <form
            onSubmit={(e) => e.preventDefault()}
            className="d-flex flex-column"
          >
            {/* Basic Details Section */}
            <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
              <h5 className="mb-3 fw-semibold text-dark">
                Nursing Task Details
              </h5>
              <div className="form-group mb-3">
                <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                  Title
                </label>
                <input
                  type="text"
                  className="form-control border border-gray-300 shadow-none"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  placeholder="Enter task title"
                />
              </div>

              <div className="row mt-3">
                <div className="col-md-6">
                  <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                    Patient
                  </label>
                  <AsyncSelect
                    value={patient}
                    onChange={setPatient}
                    loadOptions={loadPatientOptions}
                    defaultOptions={[]}
                    placeholder="Search and select patient type"
                    styles={reactSelectStyle("3px", "6px", true, false)}
                    isClearable
                  />
                  {patient ? <PatientDetailsCard patient={patient} /> : null}
                </div>
                <div className="col-md-6">
                  <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                    Ordered By (Doctor)
                  </label>
                  <AsyncSelect
                    value={doctor}
                    onChange={setDoctor}
                    loadOptions={loadDoctorOptions}
                    defaultOptions={[]}
                    placeholder="Search and select doctor"
                    styles={reactSelectStyle("3px", "6px", true, false)}
                    isClearable
                  />
                  {doctor ? <DoctorDetailsCard doctor={doctor} /> : null}
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-6">
                  <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                    Select Nurses
                  </label>
                  <AsyncSelect
                    value={nurses}
                    onChange={setNurses}
                    loadOptions={loadNurseOptions}
                    defaultOptions={[]}
                    placeholder="Search and select nurse types"
                    styles={reactSelectStyle("3px", "6px", true, false)}
                    isMulti
                  />
                  {nurses && nurses.length > 0 ? (
                    <div className="nurse-details mt-3 d-flex flex-column gap-3">
                      {nurses.map((nurse, index) => {
                        return <NurseDetailsCard nurse={nurse} key={index} />;
                      })}
                    </div>
                  ) : null}
                </div>

                <div className="col-md-6">
                  <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                    Clinic
                  </label>
                  <AsyncSelect
                    value={clinic}
                    onChange={setClinic}
                    loadOptions={loadClinicOptions}
                    defaultOptions={[]}
                    placeholder="Search and select clinic"
                    styles={reactSelectStyle("3px", "6px", true, false)}
                    isClearable
                  />
                  {clinic ? <ClinicDetailsCard clinic={clinic} /> : null}
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-md-6">
                  <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                    Schedule for
                  </label>
                  <input
                    type="date"
                    className="form-control border border-gray-300 shadow-none"
                    value={scheduleFor}
                    onChange={(e) => setScheduleFor(e.target.value)}
                  />
                </div>
                <div className="col-md-6">
                  <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                    Priority
                  </label>
                  <Select
                    value={priority}
                    onChange={setPriority}
                    options={priorityOptions}
                    placeholder="Select priority"
                    styles={reactSelectStyle("3px", "6px", true, false)}
                    isClearable
                  />
                </div>
              </div>
            </div>

            {/* Details Section */}
            <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
              <label className="d-block fs-sm fw-semibold text-dark">
                Details <span className="text-danger">*</span>
              </label>
              <JoditEditorField
                value={details}
                onChange={setDetails}
                editorHeight={300}
              />
            </div>

            {/* Instructions Section */}
            <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
              <label className="d-block fs-sm fw-semibold text-dark">
                Instructions
              </label>
              <JoditEditorField
                value={instructions}
                onChange={setInstructions}
                editorHeight={300}
              />
            </div>

            {/* Additional Information Section */}
            <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
              <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                Additional Information
              </label>
              <textarea
                className="form-control border border-gray-300 shadow-none"
                rows="4"
                value={additionalInformation}
                onChange={(e) => setAdditionalNotes(e.target.value)}
                placeholder="Enter additional information..."
              ></textarea>
            </div>

            {/* Patient Consent Section */}
            <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
              <div className="form-check d-flex align-items-center gap-2 fs-sm p-0 m-0">
                <input
                  className="form-check-input bg-transparent border-2 border-gray-600 shadow-none m-0"
                  type="checkbox"
                  id="patientConsentRequired"
                  checked={patientConsentRequired}
                  onChange={(e) => setPatientConsentRequired(e.target.checked)}
                />
                <label
                  className="form-check-label fw-semibold text-dark"
                  htmlFor="patientConsentRequired"
                >
                  Patient Consent Required
                </label>
              </div>
            </div>

            {/* Save Button */}
            <div className="action d-flex justify-content-end pt-3 border-top mt-auto">
              <button
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2"
                disabled={isSaving}
                style={{ cursor: isSaving ? "not-allowed" : "pointer" }}
                onClick={saveNursingRecord}
              >
                {isSaving ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Saving...
                  </>
                ) : (
                  <>
                    <span className="material-symbols-outlined me-1">save</span>
                    {selectedNursingId ? "Update Task" : "Save Task"}
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SaveNursingPopup;
